<template>
    <div class="card">
        <div class="pb-0 card-header mb-0">
            <h6>Ringkasan Perangkat</h6>
        </div>
        <div class="p-3 card-body">
            <div class="table-responsive p-0">
                <table class="table align-item-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7 pointer">
                                Pelanggan
                            </th>
                            <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7 pointer">
                                Tahun Online
                            </th>
                            <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7 pointer">
                                Jumlah Perangkat Aktif
                            </th>
                            <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7 pointer">
                                Jumlah Perangkat di Gudang
                            </th>
                            <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7 pointer">
                                Jumlah Sertifikat
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in data" :key="data.id">
                            <td class="text-center align-middle text-sm">{{ data.name }}</td>
                            <td class="text-center align-middle text-sm">{{ data.year }}</td>
                            <td class="text-center align-middle text-sm">{{ data.totalActive }}</td>
                            <td class="text-center align-middle text-sm">{{ data.totalGudang }}</td>
                            <td class="text-center align-middle text-sm">{{ data.totalCertificate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { ApiService } from "@/axios/apiService";

const apiService = new ApiService();
const data = ref('');
const data__ = ref('');
const sortedbyASC = ref(true);

const sortList = (param) => {
    if (sortedbyASC.value) {
        data.value.sort((x, y) => (x[param] > y[param] ? -1 : 1));
        sortedbyASC.value = false;
    } else {
        data.value.sort((x, y) => (x[param] < y[param] ? -1 : 1));
        sortedbyASC.value = true;
    }
};

onMounted(async () => {
    const data_ = await apiService.perangkatRingkasan();
    data__.value = data_.data;
    data.value = data__.value
});
</script>
  